











import Vue from "vue";
import Component from "vue-class-component";
import Modal from "@/shared/components/modal.vue";
import { ProcessamentoFilaMensagensService } from "@/services/processamentoFilaMensagem.service";

import { Watch } from "vue-property-decorator";

@Component({
  components: { Modal },
})
export default class ErroProcessamentoFilaMensagem extends Vue {
  erro: string | null = null;
  loading = false;

  @Watch("$route.params", { deep: true })
  onParamsChange() {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;
    const idItemProcessamentoFilaMensagem =
      params.idItemProcessamentoFilaMensagem;

    this.loading = true;
    ProcessamentoFilaMensagensService.obterItem(
      idProcessamentoFilaMensagem,
      idItemProcessamentoFilaMensagem
    )
      .then((item) => {
        this.erro = item.erro || "";
      })
      .finally(() => (this.loading = false));
  }

  mounted() {
    this.onParamsChange();
  }

  voltar() {
    this.$router.go(-1);
  }
}
